<template>
  <el-table :data="tableData"
            height="250"
            border
            style="width: 100%">
    <el-table-column prop="UserName"
                     label="人员名称">
    </el-table-column>
    <el-table-column prop="loginFlag"
                     label="登录"
                     width="80">
      <template v-slot="scope">
        <el-button @click="loginSys(scope.row)"
                   type="text"
                   size="small">登录</el-button>
      </template>
    </el-table-column>
    <el-table-column prop="Position"
                     label="角色">
    </el-table-column>
    <el-table-column prop="UserName"
                     label="登录账号">
    </el-table-column>
    <el-table-column label="登录密码">
      edoc2
    </el-table-column>
  </el-table>
</template>

<script>
import ApiService from '@/services/API-services'
export default {
  name: 'userList',
  data() {
    return {
      tableData: []
    }
  },
  mounted() {
    ApiService.user.getuserlist({
      // token: sessionStorage.octopus_token
    }).then(res => {
      if (res.code === 0) {
        let a = res.data.filter(n => {
          return n.IsShow === 0
        })
        this.tableData = a
      }
    })
  },
  methods: {
    loginSys(data) {
      console.log(data)
      data.PassWord = 'edoc2'
      ApiService.user.loginOctopus({
        UserName: data.UserName,
        Password: data.PassWord
      }).then(res => {
        if (res.result === 0) {
          sessionStorage.setItem('userName', this.$utils.encrypt(data.UserName))
          sessionStorage.setItem('userSign', this.$utils.encrypt(data.PassWord))
          localStorage.token = res.data
          sessionStorage.setItem('octopus_token', res.data)
          ApiService.octopus_user.getUserInfo({
            token: res.data
          }).then(res => {
            localStorage.user = JSON.stringify(res.data)
            window.location.href = '/mains.html'
          })
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/userList.vue